// import { getCurrentOrg } from '@/service/main.js'
import Vue from 'vue'

import {
  getProfile,
  getCurrentOrg
  // checkTokenExpired
} from '@/service/util'

// import store from '@/store'

// import router from '@/router/index'

// import util from '@/tools/util'
const getDefaultState = () => {
  return {
    orgProfile: {

    }
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_USER (state, payload) {
    state.orgProfile = {
      ...(state.orgProfile || {}),
      ...(payload || {})
    }
  }
}

const actions = {
  // 初始化
  initOrgProfile ({ commit }, {
    successCb,
    failCb,
    existOrg
  } = {}) {
    const {
      id: exist_org_id
    } = existOrg || {}

    if (exist_org_id) {
      const {
        roles: exist_roles
      } = existOrg || {}

      if (Array.isArray(exist_roles)) {
        if (typeof successCb === 'function') {
          successCb(existOrg)
        }
      } else {
        if (typeof failCb === 'function') {
          failCb()
        }
      }
    } else {
      getCurrentOrg((res) => {
        const {
          org
        } = res || {}

        const {
          roles
        } = org || {}

        // profile.small_avatar_uri = profile.avatar_uri ? util.smallImageURL(profile.avatar_uri, 30, 30) : '';

        commit('SET_USER', {
          roles
        })

        Vue.prototype.$cookies.set('org', org)
        Vue.prototype.$cookies.set('roles', roles)

        if (typeof successCb === 'function') {
          successCb(org)
        }
      }, {

      }, () => {
        if (typeof failCb === 'function') {
          failCb()
        }
      })
    }

    // const profile = Vue.prototype.$cookies.get('profile')
    // Vue.prototype.$cookies.remove('profile');
  },

  getUserProfile ({ commit }, {
    existProfile
  }) {
    const {
      id: exist_profile_id
    } = existProfile || {}

    if (exist_profile_id) {
      commit('SET_USER', {
        ...(existProfile || {})
      })
    } else {
      getProfile((res) => {
        const {
          profile
        } = res || {}
        commit('SET_USER', {
          ...(profile || {})
        })
      }, {

      }, () => {

      })
    }
  }

  // getOrgDetail({ commit, dispatch }) {
  //   const org_id = Vue.prototype.$cookies.get('orgid');

  //   if (org_id) {
  //     getCurrentOrg((res) => {
  //       console.log(res);

  //       let cur_org = res.org || {};

  //       Vue.prototype.$cookies.set('orgid', cur_org.id);

  //       dispatch('initOrg', cur_org);

  //       // refreshPage()

  //       // this.$store.dispatch('storeCache/clearCache');

  //       // this.$router.push({
  //       //   path: '/main/schedule'
  //       // }, () => {
  //       //   // console.log('finish onComplete')
  //       //   this.$router.replace('/refresh')
  //       // })
  //     }, {
  //       org_id
  //     })
  //   }

  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
